import axios from 'axios';
import * as types from '../constants/ActionTypes';

import Page from '../../lib/page';
import { quickAnswerLayer } from '../constants/UtilVariables';

const RELATED_ARTICLE_URL = '/smarthelp/related-article';
const WEB_TREE_URL = '/smarthelp/web-topic-tree';

// For Find Quick Answer Layer 1 data
function requestRelatedTopic() {
  return {
    type: types.REQUEST_RELATED_TOPIC,
  };
}

function receiveRelatedTopic(responseData) {
  return {
    type: types.RECEIVE_RELATED_TOPIC_RESPONSE,
    payload: responseData,
  };
}

function receiveRelatedTopicError() {
  return {
    type: types.RECEIVE_RELATED_TOPIC_ERROR,
  };
}

export function fetchRelatedTopic(topicId) {
  return (dispatch) => {
    dispatch(requestRelatedTopic());
    return axios.get(`${RELATED_ARTICLE_URL}?topic=${topicId}`)
      .then((response) => {
        if (!response.data || !response.data.length) {
          // Dispatching error actions when API returns 200 with empty response
          dispatch(receiveRelatedTopicError());
        } else {
          dispatch(receiveRelatedTopic(response.data));
        }
      })
      .catch(() => (
        dispatch(receiveRelatedTopicError())
      ));
  };
}

// For Quick Anwser Layer 2 topics and suggested related articles
function requestWebTreeTopic() {
  return {
    type: types.REQUEST_WEB_TREE_TOPICS,
  };
}

function receiveWebTreeTopic(responseData) {
  return {
    type: types.RECEIVE_WEB_TREE_TOPICS,
    payload: responseData,
  };
}

function receiveWebTreeError() {
  return {
    type: types.RECEIVE_WEB_TREE_TOPICS_ERROR,
  };
}

export function fetchWebTreeTopic(topicId) {
  return (dispatch) => {
    dispatch(requestWebTreeTopic());
    const topicURL = `${WEB_TREE_URL}?q=${topicId}`;
    return axios.get(Page.setChannelForTechnicalExp(topicURL))
      .then((response) => (
        dispatch(receiveWebTreeTopic(response.data && response.data.webTopicTree))
      ))
      .catch(() => (
        dispatch(receiveWebTreeError())
      ));
  };
}

// For each select tracking for Find quick Anwser
function selectTopic({ layer, topicId }) {
  return {
    type: types.SELECT_QUICK_TOPIC,
    payload: {
      layer,
      topicId: Page.formalQuickAnswerKey({ layer, topicId }),
    },
  };
}

export function selectQuickAnswer({ layer, topicId }) {
  return (dispatch) => {
    dispatch(selectTopic({ layer, topicId }));
    if (layer === quickAnswerLayer.layer1) {
      dispatch(fetchWebTreeTopic(topicId));
    }
  };
}
